const profileCreatedBy = [
  { label: "Self", value: "self" },
  { label: "Parents", value: "parents" },
  { label: "Brother / Sister", value: "brotherOrSister" },
  { label: "Friend / Relative", value: "friendOrRelative" },
];
export default profileCreatedBy;
